import { Pencil } from 'lucide-react'
import { formatNextRun } from '@/lib/jobSchedules'
import { describeSchedule } from '@/lib/scheduleDescription'
import { Button } from '@/components/ui/button'
import type { JobSchedule } from '@/api/types'

interface JobScheduleCellProps {
  schedule: JobSchedule | null
  isEditing: boolean
  onEdit: () => void
}

const EMPTY_VALUE = '–'
const EDIT_LABEL = 'Ändra'

export function JobScheduleCell({ schedule, isEditing, onEdit }: JobScheduleCellProps): React.ReactElement {
  if (schedule === null) {
    return <span className="text-muted-foreground">{EMPTY_VALUE}</span>
  }

  return (
    <div className="flex flex-col items-start gap-0.5">
      <p>{describeSchedule(schedule.cron)}</p>
      <p className="whitespace-nowrap text-xs text-muted-foreground tabular-nums">{formatNextRun(schedule)}</p>
      {!isEditing && (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="h-auto gap-1 p-0 text-xs has-[>svg]:px-0"
          onClick={onEdit}
        >
          <Pencil className="size-3" />
          {EDIT_LABEL}
        </Button>
      )}
    </div>
  )
}
